const jwt = require('jsonwebtoken');
import { token as secret } from "@/plugins/enums/index.js";

export function decrypt(token) 
{
    return jwt.verify(token, secret.key, function (err, decoded) 
    {
        if (err) {
            return {
                message: 'error en la session del usuario: ' + err.message.substring(0, 50),
                isError: true,
                data: {}
            }
        }
        else {
            return {
                message: '',
                isError: false,
                data: decoded
            }
        }
    });

}